<template>
  <div>
    <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectOrg" round>选择抄送人</el-button>
    <div class="option">
      <el-checkbox label="允许发起人添加抄送人" v-model="config.shouldAdd"></el-checkbox>
    </div>
    <org-items v-model="select" />
    <tree
      @update="closeTree"
      @sendList="getSelectList($event)"
      :open="open"
      :list="select"
      v-if="open"
      :companyId="EId"
      :url="url"
    ></tree>
    <zhTree
      @update="closeTree"
      @sendList="getSelectList($event)"
      :open="zhTreeOpen"
      :list="select"
      v-if="zhTreeOpen"
      :companyId="EId"
      :url="url"
    ></zhTree>
    <!-- <org-picker multiple ref="orgPicker" :selected="select" @ok="selected"/> -->
  </div>
</template>

<script>
import { insertClockInPersonnel, getUserListByManagementId } from '@/api/Industry'
import tree from '../../../shop/tree.vue'
import zhTree from '../../../shop/zhTree.vue'
import OrgPicker from '@/components/common/OrgPicker'
import OrgItems from '../OrgItems'

export default {
  name: 'CcNodeConfig.vue',
  components: { OrgPicker, OrgItems, tree, zhTree },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    select: {
      get() {
        return this.config.assignedUser || []
      },
      set(val) {
        this.config.assignedUser = val
      },
    },
  },
  data() {
    return {
      open: false,
      zhTreeOpen: false,
      selectList: [], // 勾选人员数组
      EId: this.$route.query.EId,
      url: this.$route.query.url,
      platformId: this.$route.query.platformId,
    }
  },
  methods: {
    openTree() {
      console.log(this.open, 'this.open')
      this.open = true
    },
    closeTree() {
      this.open = false
      this.zhTreeOpen = false
    },
    // 接收 子组件传递过来 的勾选人员数组
    getSelectList(list) {
      console.log(list, 'list')
      this.select.length = 0
      list.forEach((val) => this.select.push(val))
      this.selectList = list
      var arr = []
      list.forEach((i) => {
        arr.push(i.name)
      })
      console.log(arr, 'arr')
      this.peopleList = arr
    },
    // 获取 考勤组人员
    async getUserListByManagementId() {
      const res = await getUserListByManagementId({
        managementId: this.managementId,
      })
      if (res.code == 200) {
        console.log(res.data)
        this.selectList = res.data
      }
    },
    async submitForm() {
      this.PeopleLoading = true
      const res = await insertClockInPersonnel({
        item: this.selectList,
        managementId: this.managementId,
        platformId: this.platformId,
      })
      if (res) {
        if (res.code == 200) {
          this.People = false
          this.$message({
            type: 'success',
            message: '设置成功',
          })
          this.PeopleLoading = false
          this.getUserListByManagementId()
        }
      } else {
        this.PeopleLoading = false
      }
    },
    selectOrg() {
      // this.$refs.orgPicker.show()
      if (this.$route.query.platformId == 'shenpi') {
        this.open = true
      } else {
        this.zhTreeOpen = true
        console.log(111233)
      }
    },
    selected(select) {
      console.log(select)
      this.select = Object.assign([], select)
    },
    removeOrgItem(index) {
      this.select.splice(index, 1)
    },
  },
}
</script>

<style lang="less" scoped>
.option {
  color: #606266;
  margin-top: 20px;
  font-size: small;
}

.desc {
  font-size: small;
  color: #8c8c8c;
}
.org-item {
  margin: 5px;
}
</style>
